import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const GetPriceAU: Site = {
  id: 'getprice',
  logo: 'svg/getprice.svg',
  label: 'GetPrice AU',
  analyticsName: 'getprice',
  hostname: 'getprice.com.au',
  platform: 'responsive',
  selector: `${responsiveVanillaSelector}, main a`,
};
